import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isPlainLeftClick } from "../productOverlay/productOverlayContext";
import { isProductPath, productLinkState } from "./productPageOverlayContext";

export const useProductLinkInterceptor = (enabled) => {
  const location = useLocation();
  const navigate = useNavigate();
  const latest = useRef({ location, navigate, enabled });
  latest.current = { location, navigate, enabled };

  useEffect(() => {
    const onClick = (event) => {
      if (!latest.current.enabled || event.defaultPrevented || !isPlainLeftClick(event)) return;
      const anchor = event.target.closest?.("a[href]");
      if (!anchor || anchor.hasAttribute("data-overlay-skip") || anchor.hasAttribute("download")) return;
      if (anchor.closest(".product-overlay")) return;
      if (anchor.target && anchor.target !== "_self") return;

      const url = new URL(anchor.getAttribute("href"), window.location.href);
      if (url.origin !== window.location.origin || !isProductPath(url.pathname)) return;

      const { location: current, navigate: go } = latest.current;
      event.preventDefault();
      const target = url.pathname + url.search + url.hash;
      if (target === current.pathname + current.search + current.hash) return;
      window.history.scrollRestoration = "manual";
      go(target, {
        state: { fromUrlPath: current.pathname, fromUrlSearch: current.search, ...productLinkState(current) },
      });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
};
